import React from "react"

export const GoogleWorkspace = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="213" height="27" viewBox="0 0 213 27">
            <defs>
                <clipPath id="clip-path">
                    <rect
                        id="Rectangle_1436"
                        data-name="Rectangle 1436"
                        width="213"
                        height="27"
                        transform="translate(0 -0.241)"
                        fill="none"
                    />
                </clipPath>
            </defs>
            <g id="Google_Workspace_Logo_1_" data-name="Google_Workspace_Logo (1)" transform="translate(0 0.241)">
                <path
                    id="Path_651"
                    data-name="Path 651"
                    d="M1718.358,38.61h2.515l-5,18.754h-2.462L1709.373,45h-.1l-4.034,12.363h-2.462L1697.56,38.61h2.514l3.955,14.747h.1l4.06-12.232h2.253l4.06,12.232h.1Z"
                    transform="translate(-1606.793 -37.105)"
                    fill="#5f6368"
                />
                <g id="Group_2742" data-name="Group 2742" transform="translate(0 0)" clipPath="url(#clip-path)">
                    <path
                        id="Path_652"
                        data-name="Path 652"
                        d="M2129.4,148.346a6.79,6.79,0,0,1,1.86-4.9A6.338,6.338,0,0,1,2136,141.51a6.254,6.254,0,0,1,4.715,1.938,7.3,7.3,0,0,1,0,9.8,6.252,6.252,0,0,1-4.715,1.938,6.34,6.34,0,0,1-4.741-1.94,6.784,6.784,0,0,1-1.86-4.9m2.41,0a4.7,4.7,0,0,0,1.2,3.353,4.117,4.117,0,0,0,5.972,0,5.231,5.231,0,0,0,0-6.679,4.058,4.058,0,0,0-5.973,0,4.659,4.659,0,0,0-1.205,3.327"
                        transform="translate(-2015.548 -134.505)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_653"
                        data-name="Path 653"
                        d="M2410.76,155.691h-2.41V142.857h2.305v2.1h.107a3.478,3.478,0,0,1,1.506-1.742,4.177,4.177,0,0,1,2.24-.72,4.516,4.516,0,0,1,1.781.314l-.735,2.332a4.012,4.012,0,0,0-1.415-.183,3.119,3.119,0,0,0-2.37,1.1,3.68,3.68,0,0,0-1.008,2.566Z"
                        transform="translate(-2279.587 -135.432)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_654"
                        data-name="Path 654"
                        d="M2588.979,57.364h-2.907l-4.008-6.051-1.964,1.938v4.112h-2.41V38.61h2.41V50.161l5.553-5.632h3.091v.1l-5,4.977,5.239,7.648Z"
                        transform="translate(-2439.875 -37.105)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_655"
                        data-name="Path 655"
                        d="M2795.171,151.173A3.479,3.479,0,0,1,2793.7,154a5.8,5.8,0,0,1-3.693,1.153,5.862,5.862,0,0,1-3.405-1.009,5.56,5.56,0,0,1-2.1-2.658l2.148-.917a3.979,3.979,0,0,0,1.375,1.794,3.34,3.34,0,0,0,1.978.641,3.483,3.483,0,0,0,1.925-.5,1.416,1.416,0,0,0,.772-1.179q0-1.23-1.886-1.807l-2.2-.55q-3.745-.943-3.745-3.616a3.34,3.34,0,0,1,1.428-2.816,6.546,6.546,0,0,1,6.732-.249,4.411,4.411,0,0,1,1.924,2.174l-2.147.891a2.7,2.7,0,0,0-1.191-1.271,3.743,3.743,0,0,0-1.847-.458,3.094,3.094,0,0,0-1.689.471,1.358,1.358,0,0,0-.749,1.153q0,1.1,2.069,1.572l1.938.5q3.824.943,3.824,3.849"
                        transform="translate(-2635.64 -134.476)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_656"
                        data-name="Path 656"
                        d="M3020.364,155.183a5.533,5.533,0,0,1-2.58-.6,4.519,4.519,0,0,1-1.795-1.6h-.107l.107,1.781v5.658h-2.41V141.929h2.305v1.781h.107a4.519,4.519,0,0,1,1.794-1.6,5.7,5.7,0,0,1,6.875,1.388,7.4,7.4,0,0,1,0,9.692,5.512,5.512,0,0,1-4.3,1.991m-.393-2.2a3.758,3.758,0,0,0,2.907-1.31,4.729,4.729,0,0,0,1.176-3.327,4.791,4.791,0,0,0-1.176-3.327,3.911,3.911,0,0,0-5.841,0,5.415,5.415,0,0,0,0,6.679,3.816,3.816,0,0,0,2.934,1.283"
                        transform="translate(-2852.464 -134.505)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_657"
                        data-name="Path 657"
                        d="M3278.847,141.5a5.972,5.972,0,0,1,4.217,1.427,5.073,5.073,0,0,1,1.545,3.916v7.911h-2.3v-1.782h-.107a4.6,4.6,0,0,1-3.981,2.2,5.177,5.177,0,0,1-3.55-1.257,4.013,4.013,0,0,1-1.427-3.143,3.817,3.817,0,0,1,1.506-3.169,6.343,6.343,0,0,1,4.021-1.179,7.115,7.115,0,0,1,3.536.786v-.552a2.743,2.743,0,0,0-1-2.135,3.415,3.415,0,0,0-2.331-.877,3.691,3.691,0,0,0-3.2,1.7l-2.122-1.336a5.916,5.916,0,0,1,5.185-2.512m-3.114,9.328a1.925,1.925,0,0,0,.8,1.572,2.938,2.938,0,0,0,1.871.629,3.841,3.841,0,0,0,2.711-1.126,3.527,3.527,0,0,0,1.192-2.646,4.954,4.954,0,0,0-3.143-.891,4.082,4.082,0,0,0-2.449.707,2.093,2.093,0,0,0-.979,1.755"
                        transform="translate(-3098.244 -134.495)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_658"
                        data-name="Path 658"
                        d="M3521.891,155.183a6.338,6.338,0,0,1-4.741-1.938,6.9,6.9,0,0,1-1.86-4.9,6.791,6.791,0,0,1,1.86-4.9,6.339,6.339,0,0,1,4.741-1.938,5.876,5.876,0,0,1,5.632,3.693l-2.2.917a3.622,3.622,0,0,0-3.589-2.41,3.724,3.724,0,0,0-2.855,1.336,5.21,5.21,0,0,0,0,6.6,3.723,3.723,0,0,0,2.855,1.336,3.773,3.773,0,0,0,3.719-2.41l2.148.917a5.747,5.747,0,0,1-2.213,2.711,6.261,6.261,0,0,1-3.5.983"
                        transform="translate(-3327.355 -134.505)"
                        fill="#5f6368"
                    />
                    <path
                        id="Path_659"
                        data-name="Path 659"
                        d="M3766.336,155.183a6.139,6.139,0,0,1-4.662-1.938,6.844,6.844,0,0,1-1.834-4.9,6.973,6.973,0,0,1,1.781-4.885,6.4,6.4,0,0,1,9.1-.1,7.382,7.382,0,0,1,1.688,5.173l-.026.262H3762.3a4.188,4.188,0,0,0,1.257,3.038,4.061,4.061,0,0,0,6.5-1.153l2.147,1.048a6.4,6.4,0,0,1-2.4,2.541,6.636,6.636,0,0,1-3.47.917m-3.849-8.382h7.358a3.205,3.205,0,0,0-1.087-2.214,3.8,3.8,0,0,0-2.632-.877,3.494,3.494,0,0,0-2.345.838,4,4,0,0,0-1.3,2.253"
                        transform="translate(-3558.832 -134.505)"
                        fill="#5f6368"
                    />
                </g>
                <g id="Group_2743" data-name="Group 2743" transform="translate(0 0)" clipPath="url(#clip-path)">
                    <path
                        id="Path_660"
                        data-name="Path 660"
                        d="M10.819,12.593v-2.9h9.708a9.522,9.522,0,0,1,.157,1.778,9.577,9.577,0,0,1-2.512,6.784,9.7,9.7,0,0,1-7.4,2.978A10.763,10.763,0,0,1,0,10.616,10.763,10.763,0,0,1,10.769,0a10.112,10.112,0,0,1,7.274,2.926L16,4.971A7.4,7.4,0,0,0,10.769,2.9a7.614,7.614,0,0,0-7.61,7.716,7.616,7.616,0,0,0,7.61,7.719,7.1,7.1,0,0,0,5.358-2.123A6.029,6.029,0,0,0,17.7,12.6Z"
                        transform="translate(0.023 -0.559)"
                        fill="#4285f4"
                    />
                    <path
                        id="Path_661"
                        data-name="Path 661"
                        d="M420.719,148.276a6.859,6.859,0,1,1-6.858-6.836,6.752,6.752,0,0,1,6.858,6.836m-3,0a3.867,3.867,0,1,0-3.857,4.143,3.939,3.939,0,0,0,3.857-4.143"
                        transform="translate(-385.221 -134.439)"
                        fill="#ea4335"
                    />
                    <path
                        id="Path_662"
                        data-name="Path 662"
                        d="M700.659,148.276a6.86,6.86,0,1,1-6.859-6.836,6.75,6.75,0,0,1,6.859,6.836m-3,0a3.867,3.867,0,1,0-3.857,4.143,3.939,3.939,0,0,0,3.857-4.143"
                        transform="translate(-650.196 -134.439)"
                        fill="#fbbc04"
                    />
                    <path
                        id="Path_663"
                        data-name="Path 663"
                        d="M980.017,141.854v12.273c0,5.049-2.977,7.121-6.5,7.121a6.513,6.513,0,0,1-6.058-4.039l2.616-1.088a3.78,3.78,0,0,0,3.443,2.434c2.252,0,3.65-1.4,3.65-4.013v-.984h-.1a4.658,4.658,0,0,1-3.6,1.553,6.842,6.842,0,0,1,0-13.672,4.734,4.734,0,0,1,3.6,1.528h.1v-1.113Zm-2.641,6.448c0-2.408-1.6-4.17-3.65-4.17a4.158,4.158,0,0,0,0,8.286,3.819,3.819,0,0,0,3.65-4.116"
                        transform="translate(-915.21 -134.439)"
                        fill="#4285f4"
                    />
                    <rect
                        id="Rectangle_1437"
                        data-name="Rectangle 1437"
                        width="3.003"
                        height="20.026"
                        transform="translate(66.891 0.233)"
                        fill="#34a853"
                    />
                    <path
                        id="Path_664"
                        data-name="Path 664"
                        d="M1344.308,150.528l2.33,1.553a6.794,6.794,0,0,1-5.7,3.03,6.689,6.689,0,0,1-6.782-6.836,6.5,6.5,0,0,1,6.446-6.836,6.352,6.352,0,0,1,5.851,4.35l.311.777-9.141,3.78a3.477,3.477,0,0,0,3.314,2.071,3.9,3.9,0,0,0,3.368-1.89m-7.171-2.459,6.11-2.537a2.645,2.645,0,0,0-2.537-1.45,3.749,3.749,0,0,0-3.573,3.988"
                        transform="translate(-1262.819 -134.439)"
                        fill="#ea4335"
                    />
                </g>
            </g>
        </svg>
    )
}
